import type { EnvironmentConfig } from "./environment.types";

/**
 * Local environment — aligned with EU local.qa.ts from data-access.
 * Uses absolute URLs (same as existing monorepo apps).
 * Browser requests pass Cloudflare's TLS/bot checks natively.
 * Auth0 credentials match the home app's local-eu config so tokens are valid.
 */
export const environment: EnvironmentConfig = {
  production: false,
  envName: "local",
  APPLICATION_NAME: "e-invoicing",
  BASE_PATH: "/",
  // Absolute URLs — matching EU local.qa.ts (same as monorepo apps)
  REACT_APP_E_INVOICING_API_ENDPOINT:
    "https://qa.flows.e-invoicing-eng.sage.com/api/",
  ALLOWED_HOST_ORIGINS: "*",
  ENABLE_PENDO_TRACKING: false,
  PENDO_API_KEY: "",
  NEW_RELIC: {
    enabled: false,
    accountId: "",
    trustKey: "",
    agentID: "",
    licenseKey: "",
    applicationId: ""
  },
  LOGGER: {
    enabled: true,
    enableConsole: true
  }
};
